import React from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/images/logo.png";
import signup from "../../../assets/images/signin.png";
import signup_logo from "../../../assets/images/signin.png";
import login_logo from "../../../assets/images/login.png";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../actions/auth";

export default function Header() {
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  return (
    <div className="row mx-auto px-md-5 py-4 intro-y align-items-center">
      <div className="col-md-7 mt-3 mt-md-1 intro-x">
        <div className="d-flex align-items-center">
          <Link
            className="d-flex align-items-center zoom-in hover-shade br-20 py-2 px-3 text-dark"
            to="/"
          >
            <img src={logo} height="25px" width="25px" alt="logo" />
            <h2 className="mb-0 px-1 font-weight-bold text-black">Billing App</h2>
          </Link>
        </div>
      </div>
      <div className="col-md-5 col mt-3 ml-auto mt-md-1 intro-x">
        {isAuthenticated ? (
          <div className="d-flex justify-content-end">
            <button className="mx-2 br-20 b-sky px-3 btn small py-1 hover-shade hover-light-sky zoom-in">
              <Link to="/memberportal" className="text-black">
                <span className="">Member Portal</span>
              </Link>
            </button>
            <button className="mx-2 br-20 b-sky px-3 btn small py-1 hover-shade hover-light-sky zoom-in">
              <Link to="/profile" className="text-black">
                <img
                  src="/profile.png"
                  height="15px"
                  className="pr-2 mb-1"
                  alt="sign-up"
                />
                <span className="">My Account</span>
              </Link>
            </button>
            <button
              onClick={() => dispatch(logout())}
              to="/sign-up"
              className="mx-2 text-white br-20 b-sky bg-sky px-3 btn small py-1 hover-shade hover-light-sky zoom-in"
            >
              <img
                height="17px"
                className="pr-2"
                src="/logout.png"
                alt="login img"
              />
              <span className="">Logout</span>
            </button>
          </div>
        ) : (
          <div className="d-flex justify-content-end">
            <button className="br-20 mx-2 b-sky px-3 btn small py-1 hover-shade hover-light-sky zoom-in">
              {/* <i className="fa fa-pencil-square-o pr-2"></i> */}
              <Link to="/sign-up" className="text-black">
                <img
                  src={signup_logo}
                  height="17px"
                  className="pr-2"
                  alt="sign-up"
                />
                <span className="">Sign Up</span>
              </Link>
            </button>
            <button className="br-20 mx-2 bg-sky border-0 px-3 btn small py-1 text-white shade-sky hover-shade zoom-in">
              {/* <i className="fa fa-sign-in pr-2"></i> */}
              <Link to="/Login" className="text-white">
                <img
                  height="17px"
                  className="pr-2"
                  src={login_logo}
                  alt="login img"
                />
                <span className="">Login</span>
              </Link>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
